(() => {
  if (window.LasgymWishlist) return;
  const dialog = document.getElementById('LgWishlistDialog');
  if (!dialog) return;
  const strings = JSON.parse(dialog.querySelector('[data-lg-wishlist-translations]').textContent);
  const list = dialog.querySelector('[data-lg-wishlist-list]');
  const message = dialog.querySelector('[data-lg-wishlist-message]');
  const retry = dialog.querySelector('[data-lg-wishlist-retry]');
  const status = document.getElementById('LgWishlistStatus');
  const storageKey = 'lasgym:wishlist:v1';
  const root = dialog.dataset.rootUrl.replace(/\/?$/, '/');
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const parseSaved = value => {
    try { const items = JSON.parse(value || '[]'); return Array.isArray(items) ? [...new Set(items.filter(validHandle))] : []; }
    catch (_) { return []; }
  };
  let handles = [];
  try { handles = parseSaved(localStorage.getItem(storageKey)); } catch (_) {}
  let version = 0;
  let opener;
  let syncPending = false;
  const products = new Map();
  const titles = new Map();
  const numericAmount = value => {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    if (typeof value === 'string' && !value.trim()) return null;
    const amount = Number(value);
    return Number.isFinite(amount) && amount >= 0 ? amount : null;
  };
  const money = value => new Intl.NumberFormat(dialog.dataset.locale || document.documentElement.lang, {style:'currency',currency:window.Shopify?.currency?.active || dialog.dataset.currency}).format(value / 100);
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const announce = text => { status.textContent = ''; requestAnimationFrame(() => { status.textContent = text; }); };
  const sync = () => {
    document.querySelectorAll('[data-lg-wishlist-toggle]').forEach(button => {
      const handle = button.dataset.productHandle;
      const saved = handles.includes(handle);
      const title = button.dataset.productTitle || titles.get(handle) || '';
      if (title) titles.set(handle, title);
      const actionLabel = saved ? button.dataset.lgWishlistLabelRemove || strings.remove : button.dataset.lgWishlistLabelAdd || strings.add;
      const label = button.querySelector('[data-lg-wishlist-label]');
      if (label && label.textContent !== actionLabel) label.textContent = actionLabel;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', actionLabel + (title ? ': ' + title : ''));
    });
    document.querySelectorAll('[data-lg-wishlist-count]').forEach(count => {
      const value = String(handles.length);
      if (count.textContent !== value) count.textContent = value;
      count.hidden = handles.length === 0;
    });
  };
  const loadProduct = handle => {
    if (!products.has(handle)) products.set(handle, fetch(productUrl(handle) + '.js', {headers:{Accept:'application/json'}}).then(response => {
      if (!response.ok) throw new Error(String(response.status));
      return response.json();
    }).catch(error => { products.delete(handle); throw error; }));
    return products.get(handle);
  };
  const actions = (handle, title, available = true) => {
    const row = element('div', 'LgWishlist__Actions');
    const link = element('a', 'LgWishlist__Link', available ? strings.buy : strings.view);
    link.href = productUrl(handle);
    const remove = element('button', 'LgWishlist__Remove', strings.remove);
    remove.type = 'button';
    remove.dataset.lgWishlistToggle = '';
    remove.dataset.productHandle = handle;
    remove.dataset.productTitle = title;
    remove.setAttribute('aria-pressed', 'true');
    remove.setAttribute('aria-label', strings.remove + ': ' + title);
    row.append(link, remove);
    return row;
  };
  const renderProduct = (item, handle, product) => {
    const title = product.title || titles.get(handle) || strings.saved_product;
    titles.set(handle, title);
    const photoLink = element('a', 'LgWishlist__Image');
    photoLink.href = productUrl(handle);
    const imageUrl = product.featured_image;
    if (imageUrl) {
      const image = document.createElement('img');
      const source = new URL(imageUrl, location.origin);
      source.searchParams.set('width', '180');
      if (source.protocol === 'https:' || source.protocol === 'http:') image.src = source.href;
      image.alt = title;
      image.width = 90;
      image.height = 120;
      image.loading = 'lazy';
      photoLink.append(image);
    } else photoLink.setAttribute('aria-label', title);
    const copy = element('div');
    const name = element('a', 'LgWishlist__Name', title);
    name.href = productUrl(handle);
    const price = element('p', 'LgWishlist__Price');
    const currentPrice = numericAmount(product.price);
    const comparePrice = numericAmount(product.compare_at_price);
    if (currentPrice !== null && comparePrice !== null && comparePrice > currentPrice) price.append(element('del', '', money(comparePrice)));
    if (currentPrice !== null) price.append(element('span', '', (product.price_varies ? strings.from + ' ' : '') + money(currentPrice)));
    copy.append(name, price);
    if (!product.available) copy.append(element('p', 'LgWishlist__Availability', strings.unavailable));
    copy.append(actions(handle, title, product.available));
    item.replaceChildren(photoLink, copy);
  };
  const render = async () => {
    const current = ++version;
    const saved = [...handles].reverse();
    list.replaceChildren();
    retry.hidden = true;
    message.textContent = saved.length ? strings.loading : strings.empty;
    if (!saved.length) return;
    const items = saved.map(handle => {
      const item = element('li', 'LgWishlist__Item');
      item.dataset.handle = handle;
      item.setAttribute('aria-busy', 'true');
      item.append(element('span', '', strings.loading));
      list.append(item);
      return {handle, item};
    });
    let position = 0;
    let failures = 0;
    const worker = async () => {
      while (position < items.length && current === version) {
        const {handle, item} = items[position++];
        try {
          const product = await loadProduct(handle);
          if (current !== version) return;
          renderProduct(item, handle, product);
        } catch (_) {
          if (current !== version) return;
          failures += 1;
          const title = titles.get(handle) || strings.saved_product;
          const copy = element('div');
          copy.style.gridColumn = '1 / -1';
          copy.append(element('p', 'LgWishlist__Name', title), element('p', 'LgWishlist__Availability', strings.load_error), actions(handle, title, false));
          item.replaceChildren(copy);
        }
        item.removeAttribute('aria-busy');
      }
    };
    await Promise.all(Array.from({length:Math.min(4, items.length)}, worker));
    if (current !== version) return;
    message.textContent = failures ? strings.load_error : '';
    retry.hidden = failures === 0;
  };
  const toggle = (handle, title = '') => {
    if (!validHandle(handle)) return;
    if (title) titles.set(handle, title);
    const saved = handles.includes(handle);
    handles = saved ? handles.filter(value => value !== handle) : [...handles, handle];
    let persisted = true;
    try { localStorage.setItem(storageKey, JSON.stringify(handles)); } catch (_) { persisted = false; }
    sync();
    announce((title ? title + '. ' : '') + (saved ? strings.removed : strings.added) + (persisted ? '' : ' ' + strings.storage_error));
    document.dispatchEvent(new CustomEvent('lasgym:wishlist:change', {detail:{handles:[...handles]}}));
    if (dialog.open) {
      render();
      dialog.querySelector('[data-lg-wishlist-close]').focus();
    }
  };
  const open = trigger => {
    opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('LgWishlistIsOpen');
    document.querySelectorAll('[data-lg-wishlist-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
    products.clear();
    render();
  };
  dialog.addEventListener('close', () => {
    version += 1;
    document.documentElement.classList.remove('LgWishlistIsOpen');
    document.querySelectorAll('[data-lg-wishlist-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-lg-wishlist-toggle],[data-lg-wishlist-open],[data-lg-wishlist-close],[data-lg-wishlist-retry]');
    if (!control) return;
    event.preventDefault();
    if (control.hasAttribute('data-lg-wishlist-toggle')) toggle(control.dataset.productHandle, control.dataset.productTitle);
    else if (control.hasAttribute('data-lg-wishlist-open')) open(control);
    else if (control.hasAttribute('data-lg-wishlist-close')) dialog.close();
    else { products.clear(); render(); }
  });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    handles = parseSaved(event.newValue);
    sync();
    if (dialog.open) render();
  });
  new MutationObserver(records => {
    if (syncPending || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-lg-wishlist-toggle],[data-lg-wishlist-count]') || node.querySelector('[data-lg-wishlist-toggle],[data-lg-wishlist-count]'))))) return;
    syncPending = true;
    requestAnimationFrame(() => { syncPending = false; sync(); });
  }).observe(document.body, {childList:true,subtree:true});
  window.LasgymWishlist = {open,toggle,has:handle => handles.includes(handle),refresh:sync};
  sync();
})();
